import { useEffect, useRef, useState } from 'react';
import styles from './StepModal.module.scss';
import { useNavigate } from 'react-router-dom';
import { isDesktop, isMIUI, isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import useMobileSlide from '../../hook/MobileSlide';
import { useForm } from 'react-hook-form';
import slide from '../../assets/slide.png';
import close from '../../assets/close.png';
import step from '../../assets/step.png';
import stepResult from '../../assets/stepResult.png';
import stepResult2 from '../../assets/stepResult2.png';
import stepResult3 from '../../assets/stepResult3.png';
import stepResult4 from '../../assets/stepResult4.png';
import axiosClient from '../../libs/axiosClient';
import Loading from '../Loading/Loading';

interface IPropsType {
  closer: React.Dispatch<React.SetStateAction<boolean>>;
  productId?: number;
}

interface IAnswer {
  answer_id: string;
  text: string;
}

interface IStepType {
  answers: IAnswer[];
  question_id: string;
  text: string;
  parent_question_id: string;
  description: string;
}

function StepModal(props: IPropsType) {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const { modalRef, handleTouchStart, handleTouchMove, handleTouchEnd } =
    useMobileSlide({ closer: props.closer });
  // 결과페이지인지 설문페이지인지
  const [isResult, setIsResult] = useState(false);
  // 결과페이지에서 결과버튼 보여줄지 말지 여부
  const [resultBtn, setResultBtn] = useState(false);
  const [stepList, setStepList] = useState<IStepType[]>([]);
  const [subList, setSubList] = useState<IStepType[]>([]);
  const [stepKey, setStepKey] = useState<string[]>([]);
  const [resultStep, setResultStep] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getStepList = async () => {
    await axiosClient.get('/data/survey?name=step_recommend').then((res) => {
      setStepList(res.data.data.questions);
    });
  };

  useEffect(() => {
    getStepList();
  }, []);

  useEffect(() => {
    if (!stepList) return;

    // 하위질문 저장
    setSubList([...stepList.filter((filter) => /-.*\./.test(filter.text))]);

    // 질문 watch 키값 저장
    setStepKey([...stepList.map((item) => item.question_id)]);
  }, [stepList]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    if (!isResult && stepKey) {
      stepKey.map((item) => setValue(item.toString(), 0));
    }
    if (isDesktop && !isResult) setResultBtn(false);
    else setResultBtn(true);
  }, [isResult, stepKey]);

  const onSubmit = () => {
    if (isResult) navigate('?');

    let formData = new FormData();

    const stepList: any = stepKey.map((item) => watch()[item]);

    formData.append('questionnaire_name', 'step_recommend');
    stepList.forEach((item: any) => {
      if (item !== 0) formData.append(`answer_ids`, item);
    });

    axiosClient
      .post('/func/survey', formData, {
        withCredentials: true,
      })
      .then((res) => {
        setIsLoading(true);
        setIsResult(true);
        setResultStep(res.data.data.step_recommend);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onLoadFinish = () => {
    if (resultStep !== null) setIsLoading(false);
    // setIsLoading(true);
  };

  const onSubmitError = (error: any) => {
    let errorList: { message: string; ref: HTMLElement }[] =
      Object.values(error);
    // window.scrollTo(
    //   0,
    //   window.scrollY + errorList[0].ref.getBoundingClientRect().top - 150,
    // );
    alert(errorList[0].message);
  };

  // const [renderStart, setRenderStart] = useState(false);
  let renderStart = false;

  const renderSubSteps = (
    parentQuestionId: string,
    answerId: string,
    margin?: number,
  ) => {
    renderStart = true;
    const filteredSubs = subList.filter(
      (sub) => sub.parent_question_id === parentQuestionId,
    );
    return filteredSubs.map((sub) => {
      if (
        watch()[sub.parent_question_id] !== 0 &&
        watch()[sub.parent_question_id.toString()] !== answerId
      ) {
        return (
          <div
            style={{ marginTop: margin && margin + 'px' }}
            key={sub.question_id}
            className={`${styles.stepFrame} ${
              errors[sub.question_id.toString()] ? styles.warningFrame : ''
            }`}
            {...register(sub.question_id.toString(), {
              value: 0,
              validate: () =>
                watch()[sub.question_id.toString()] === 0
                  ? `${sub.text} 질문을 선택해주세요.`
                  : true,
            })}
          >
            <div className={styles.titleWrap}>{sub.text}</div>
            <div className={styles.ansListWrap}>
              {sub.answers.map((subAnswer) => (
                <div
                  key={subAnswer.answer_id}
                  className={`${styles.ansFrame} ${
                    watch()[sub.question_id.toString()] === subAnswer.answer_id
                      ? styles.hit
                      : ''
                  }`}
                  onClick={() => {
                    setValue(sub.question_id.toString(), subAnswer.answer_id);
                  }}
                >
                  <div className={styles.customRadioBox}></div>
                  <span>{subAnswer.text}</span>
                </div>
              ))}
            </div>
            {renderSubSteps(sub.question_id, sub.answers[0].answer_id, 8)}
          </div>
        );
      }
      return null;
    });
  };

  const { t, i18n } = useTranslation();

  return (
    <div className={`${styles.container} ${isDesktop ? styles.isDesktop : ''}`}>
      <div
        ref={modalRef}
        className={`${styles.contentWrap} ${
          isResult && styles.resultContentWrap
        }`}
      >
        {isDesktop ? (
          <div className={styles.closeWrap}>
            <img
              src={close}
              alt="close"
              onClick={() => {
                navigate(`/productDetail/${props.productId}`);
                props.closer(false);
              }}
            />
          </div>
        ) : (
          <div
            className={styles.slideWrap}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <img src={slide} alt="slide" />
          </div>
        )}
        {isResult ? (
          <div className={styles.mainWrap}>
            <div className={styles.leftWrap}>
              <div className={`${styles.bigTextWrap} ${styles.resultTextWrap}`}>
                <span>
                  {t('stepModal.14')}
                  <br />
                  {t('stepModal.15')}{' '}
                  <span className={styles.hit}>
                    {t('stepModal.13')}
                    {resultStep}!
                  </span>
                </span>
              </div>
              <div className={styles.resultImgWrap}>
                {resultStep === 1 && <img src={stepResult} alt="result" />}
                {resultStep === 2 && <img src={stepResult2} alt="result" />}
                {resultStep === 3 && <img src={stepResult3} alt="result" />}
                {resultStep === 4 && <img src={stepResult4} alt="result" />}
              </div>
            </div>
            <div className={styles.rightWrap}>
              <div className={styles.resultSubWrap}>
                {resultStep === 1 && (
                  <span>
                    {t('stepModal.16')}{' '}
                    <span className={styles.hit}>{t('stepModal.17')}</span>
                    <br />
                    {t('stepModal.18')}{' '}
                    <span className={styles.hit}>{t('stepModal.19')}</span>
                    {/* 들에게
                    {isMobile && <br />}
                    추천드립니다. */}
                  </span>
                )}
                {resultStep === 2 && (
                  <span>
                    {t('stepModal.20')}{' '}
                    <span className={styles.hit}>{t('stepModal.21')} </span>
                    <br />
                    {isMobile && <br />}
                    <span className={styles.hit}>{t('stepModal.22')}</span>
                  </span>
                )}
                {resultStep === 3 && (
                  <span>
                    {t('stepModal.23')}{' '}
                    <span className={styles.hit}>{t('stepModal.24')}</span>
                    {isMobile && <br />}
                    {t('stepModal.25')}
                    <span className={styles.hit}>{t('stepModal.26')}</span>
                  </span>
                )}
                {resultStep === 4 && (
                    <span>
                      {t('stepModal.27')}{' '}
                      <span className={styles.hit}>{t('stepModal.28')}</span>
                      {isMobile && <br />}
                      {t('stepModal.29')}
                      <span className={styles.hit}>{t('stepModal.30')}</span>
                      {isMobile && <br />}
                      {t('stepModal.31')}
                  </span>
                )}
                <br />
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.mainWrap}>
            <div className={styles.leftWrap}>
              <div className={styles.bigTextWrap}>
                <span>
                  {t('stepModal.1')}
                  <br /> {t('stepModal.2')}
                  <br />
                  {t('stepModal.3')}{' '}
                  <span className={styles.hit}>{t('stepModal.4')}</span>
                </span>
              </div>
              <div className={styles.stepWrap}>
                <div className={styles.stepLeftWrap}>
                  <span>{t('stepModal.5')}</span>
                  <div>
                    <span>{t('stepModal.6')}</span>
                  </div>
                </div>
                <img src={step} alt="step" />
              </div>
            </div>
            <div className={styles.rightWrap}>
              {/* {renderSteps(
                stepList && stepList.filter((step) => !/-.*\./.test(step.text)),
              )} */}
              {stepList &&
                stepList
                  .filter((filter) => !/-.*\./.test(filter.text))
                  .map((step, quesIdx) => (
                    <div
                      key={step.question_id}
                      className={`${styles.stepFrameWrap} ${
                        errors[`${step.question_id}`] ? styles.warning : ''
                      }`}
                      {...register(`${step.question_id}`, {
                        value: 0,
                        validate: () =>
                          watch()[`${step.question_id}`] === 0
                            ? `'${step.text}' 질문을 선택해주세요.`
                            : true,
                      })}
                    >
                      <div className={styles.stepFrame}>
                        <div className={styles.titleWrap}>{step.text}</div>
                        <div className={styles.ansListWrap}>
                          {step.answers.map((answer, answerIdx) => (
                            <div
                              key={answer.answer_id}
                              className={`${styles.ansFrame} ${
                                watch()[`${step.question_id}`] ===
                                answer.answer_id
                                  ? styles.hit
                                  : ''
                              }`}
                              onClick={() => {
                                setValue(
                                  `${step.question_id}`,
                                  answer.answer_id,
                                );
                              }}
                            >
                              <div className={styles.customRadioBox}></div>
                              <span>{answer.text}</span>
                            </div>
                          ))}
                        </div>
                        {step.description && (
                          <div className={styles.subWrap}>
                            {step.description}
                          </div>
                        )}
                      </div>
                      {renderSubSteps(
                        step.question_id,
                        step.answers[0].answer_id,
                      )}
                    </div>
                  ))}
              {renderStart && (
                <div className={styles.resultBtnWrap}>
                  <div className={styles.alertTextWrap}>
                    {t('stepModal.8')}
                    <br />
                    {t('stepModal.9')}
                    <br />
                    {t('stepModal.10')}
                  </div>
                  <div className={styles.btnWrap}>
                    {isResult && (
                      <div
                        className={styles.reStepBtn}
                        onClick={() => {
                          setIsResult(false);
                          setResultStep(undefined);
                        }}
                      >
                        <span>{t('stepModal.11')}</span>
                      </div>
                    )}
                    <div
                      className={styles.resultBtn}
                      onClick={handleSubmit(onSubmit, onSubmitError)}
                    >
                      {isResult ? (
                        <span>{t('stepModal.12')}</span>
                      ) : (
                        <span>{t('stepModal.7')}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {resultBtn && (
          <div className={styles.resultBtnWrap}>
            <div className={styles.alertTextWrap}>
              {t('stepModal.8')} <br />
              {isMobile && <br />} {t('stepModal.9')} {isMobile && <br />}
              {t('stepModal.10')}
            </div>
            <div className={styles.btnWrap}>
              {isResult && (
                <div
                  className={styles.reStepBtn}
                  onClick={() => {
                    setIsResult(false);
                    setResultStep(undefined);
                  }}
                >
                  <span>{t('stepModal.11')}</span>
                </div>
              )}
              <div
                className={styles.resultBtn}
                onClick={handleSubmit(onSubmit, onSubmitError)}
              >
                {isResult ? (
                  <span>{t('stepModal.12')}</span>
                ) : (
                  <span>{t('stepModal.7')}</span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {/* {isLoading && <Loading closer={setIsLoading} />} */}
      {isLoading && <Loading onLoadFinish={onLoadFinish} />}
    </div>
  );
}

export default StepModal;
